import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ItinerariesQueryVariables = Types.Exact<{
  date: Types.Scalars['Date'];
  courierId: Types.Scalars['Int'];
}>;


export type ItinerariesQuery = { __typename?: 'Query', Itineraries: Array<{ __typename?: 'ItineraryVersion', id: any, courierId: number, createdDate: any, endLatitude: number, endLongitude: number, startLatitude: number, startLongitude: number, isCourierOrder: boolean, smallAndNormalAwbDeliveryTime?: number | null, largeAwbDeliveryTime?: number | null, parkingTime?: number | null, approximateLocationAdditionalTime?: number | null, oohAdditionalTime?: number | null, startingTime: any, provider?: string | null, isLateRefill: boolean, itineraryStops: Array<{ __typename?: 'ItineraryStop', id: any, address?: string | null, arrival?: any | null, identifiers?: string | null, identifiersDescriptions?: string | null, county?: string | null, departure?: any | null, notificationIntervalStart?: any | null, notificationIntervalStop?: any | null, order: number, town?: string | null, village?: string | null, latitude?: number | null, longitude?: number | null, jobType: Types.JobType, stopType: Types.StopType, containsR30Awbs: boolean }>, pauseIntervals: Array<{ __typename?: 'ItineraryVersionPauseInterval', id: any, startTime: any, endTime: any }>, itineraryWarnings: Array<{ __typename?: 'KeyValuePairOfStringAndListOfItineraryWarning', key: string, value: Array<{ __typename?: 'ItineraryWarning', id: any, errorCode?: string | null, errorMessage?: string | null }> }> }> };


export const ItinerariesDocument = gql`
    query Itineraries($date: Date!, $courierId: Int!) {
  Itineraries(date: $date, courierId: $courierId) {
    id
    courierId
    createdDate
    endLatitude
    endLongitude
    startLatitude
    startLongitude
    isCourierOrder
    smallAndNormalAwbDeliveryTime
    largeAwbDeliveryTime
    parkingTime
    approximateLocationAdditionalTime
    oohAdditionalTime
    startingTime
    provider
    isLateRefill
    itineraryStops {
      id
      address
      arrival
      identifiers
      identifiersDescriptions
      county
      departure
      notificationIntervalStart
      notificationIntervalStop
      order
      town
      village
      latitude
      longitude
      jobType
      stopType
      containsR30Awbs
    }
    pauseIntervals {
      id
      startTime
      endTime
    }
    itineraryWarnings {
      key
      value {
        id
        errorCode
        errorMessage
      }
    }
  }
}
    `;

/**
 * __useItinerariesQuery__
 *
 * To run a query within a React component, call `useItinerariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItinerariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItinerariesQuery({
 *   variables: {
 *      date: // value for 'date'
 *      courierId: // value for 'courierId'
 *   },
 * });
 */
export function useItinerariesQuery(baseOptions: Apollo.QueryHookOptions<ItinerariesQuery, ItinerariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItinerariesQuery, ItinerariesQueryVariables>(ItinerariesDocument, options);
      }
export function useItinerariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItinerariesQuery, ItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItinerariesQuery, ItinerariesQueryVariables>(ItinerariesDocument, options);
        }
export type ItinerariesQueryHookResult = ReturnType<typeof useItinerariesQuery>;
export type ItinerariesLazyQueryHookResult = ReturnType<typeof useItinerariesLazyQuery>;
export type ItinerariesQueryResult = Apollo.QueryResult<ItinerariesQuery, ItinerariesQueryVariables>;